import { Storage } from 'aws-amplify'

export async function downloadfile (projectid, file_name) {
    console.log('in download js', projectid, file_name)
    // return new Promise(resolve => {
        let result = await Storage.get(`files/${projectid}/${file_name}`, {
            level: 'private',
            download: true,
            //contentType?: string // set return content type, eg "text/html"
            });
        console.log(result)
        downloadBlob(result.Body, file_name)
    // });
};

const downloadBlob = (blob, filename) => {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename || 'download';
    const clickHandler = () => {
        setTimeout(() => {
        URL.revokeObjectURL(url);
        a.removeEventListener('click', clickHandler);
        }, 150);
    };
    a.addEventListener('click', clickHandler, false);
    a.click();
    return a;
}